import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=4442af84&scoped=true"
import script from "./Teams.vue?vue&type=script&lang=js"
export * from "./Teams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4442af84",
  null
  
)

export default component.exports